import useNavigation from 'hooks/app/useNavigation';
import React from 'react';

export default function useNavAction(page, { category }) {
  const { push, frontPageTags } = useNavigation(category);
  const triggered = React.useMemo(() => {
    if (typeof page === 'string') {
      return frontPageTags.includes(page);
    } else {
      return frontPageTags.includes(page.name);
    }
  }, [frontPageTags, page]);
  const onTrigger = React.useCallback((callback) => () => {
    callback && callback(page);
    push(page);
  }, [push, page]);
  return {
    triggered,
    onTrigger,
  };
}
